{
	"title": "Projekty",
	"table": {
		"reference": "Odniesienie",
		"quantity": "Łączna ilość",
		"savings": "Łączne redukcje emisji CO\u2082",
		"fetchError": "Nie udało się pobrać projektów"
	},
	"showProjectsHistoryTitle": "Pokaż historię projektów",
	"noProjects": {
		"createDeclaration": "Utwórz swoją pierwszą deklarację",
		"description": "Możesz utworzyć deklaracje dla jednego lub wielu materiałów, klikając „Utwórz deklarację”."
	}
}
